import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.js';
import { createRecipe } from './create-recipe.js';

const toggleDefaultVariants = {
  "disabled": false,
  "selected": false
}
const toggleCompoundVariants = []

const toggleSlotNames = [
  [
    "root",
    "toggle__root"
  ],
  [
    "backdrop",
    "toggle__backdrop"
  ],
  [
    "dot",
    "toggle__dot"
  ]
]
const toggleSlotFns = /* @__PURE__ */ toggleSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, toggleDefaultVariants, getSlotCompoundVariant(toggleCompoundVariants, slotName))])

const toggleFn = memo((props = {}) => {
  return Object.fromEntries(toggleSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const toggleVariantKeys = [
  "selected",
  "disabled"
]
const getVariantProps = (variants) => ({ ...toggleDefaultVariants, ...compact(variants) })

export const toggle = /* @__PURE__ */ Object.assign(toggleFn, {
  __recipe__: false,
  __name__: 'toggle',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: toggleVariantKeys,
  variantMap: {
  "selected": [
    "true",
    "false"
  ],
  "disabled": [
    "true",
    "false"
  ]
},
  splitVariantProps(props) {
    return splitProps(props, toggleVariantKeys)
  },
  getVariantProps
})